export const groupConstants = {
    GROUP_NAME: 'GROUP NAME',
    FOCUS: 'FOCUS',
    SUB_FOCUS: 'SUB FOCUS',
    PRIVACY: 'PRIVACY',
    DESCRIPTION: 'DESCRIPTION',
    TERMS_CONDITION: 'Terms and Conditions',
    TERMS_CONDITION_CHECK: 'I AGREE TO THE TERMS AND CONDITIONS',
    REQUESTOR_NAME: 'REQUESTOR NAME :',
    REQUEST_GROUP: 'Request a Group',
    SAVE: 'Save',
    CONFIRM_DENY: 'Confirm and Deny',
    CANCEL: 'Cancel',
    SKIP: 'Skip',
    BACK: 'Back',
    APPROVE: 'Approve',
    DENY: 'Deny',
    TandC_DOCUMENT: 'https://media.ypowpo.org/libraries/legal/GroupRequestTAC.pdf',
    PUBLIC: 'Public',
    PRIVATE: 'Private',
    SECRET: 'Secret',
    GROUP_CONFIGURATION: 'GROUP CONFIGURATION',
    DENIAL_REASON: 'Please enter a reason for denial :',
    REQUEST_NEW_GROUP: 'Request A New Group',
    REQUEST_NEW_GROUP_ID: 'request_a_new_group',

    PUBLIC_GROUP: 'Anyone can see the group and its content, and users are able to join without approval.',
    PRIVATE_GROUP:
        'Private - Anyone can find the group, but participants must request approval before viewing a private group content.',
    SECRET_GROUP:
        'Secret - Only participants can find the group through search and users must be invited by current participants to gain access to private group content.',

    VALIDATIONS: {
        NAME_REQUIRED: 'Group Name is required',
        NAME_LENGTH_VALIDATION: 'Group Name must be less than 50 characters',
        ITEM_REQUIRED: 'Item is required',
        DESCRIPTION_ERROR: 'The description should be 1-256 characters',
        REJECTION_REASON_ERROR: 'The denial reason should be 1-100 characters',
        CREATION_SUCCESS: 'Your request has been submitted successfully!',
        CREATION_ERROR: 'Group creation request unsuccessful',
        APPROVE_ERROR: 'Group Request Approval unsuccessful',
        APPROVE_SUCCESS: `Approval complete <br />Requestor has been notified`,
        REJECT_ERROR: 'Group Request Rejection unsuccessful',
        REJECT_SUCCESS: 'Denial complete <br/> Requestor has been notified',
        UPDATE_SUCCESS: 'Group info updated successfully',
        UPDATE_ERROR: 'Group info update unsuccessful',
        ALREADY_EXSIST: 'already exist',
        GROUPNAME_ALREADY_EXISTS: 'Group Name already exists',
    },
};

export const Administration = {
    GROUP_ADMINISTRATION: 'Group Administration',
};

export const ManageParticipants = {
    IAMLOOKINGFOR: `I’m looking for…`,
    SEARCH_FOR_MEMBERS: 'Search to manage participants',
    MANAGE_GROUP_ADMINISTRATORS: 'Manage Group Administrators',
    ERROR_WHILE_MANAGING_ADMIN_PERMISSION: 'Error While Managing Admin Permission',
    MEMBER_ALREADY_ADDED: 'Member Already Added',
    ERROR_WHILE_REMOVING_MEMBER: 'Error While Removing Member',
    MAKE_ADMINISTRATOR: 'Make Administrator?',
    ARE_YOU_SURE_TO_REMOVE_THE_MEMBER_AS_AN_ADMIN: `Are you sure you want to remove the member's admin privileges ?`,
    ARE_YOU_SURE_TO_ADD_THE_MEMBER_AS_AN_ADMIN: `Are you sure you want to add the member as an admin ?`,
    ARE_YOU_SURE_TO_REMOVE_THE_MEMBER: 'Are you sure you want to remove the member ?',
    actions: {
        removeMember: 'remove member',
        toggleAdmin: 'toggle admin',
    },
    YES: 'Yes',
    NO: 'No',
    CONFIRM: 'Confirm',
    REMOVE_ADMINISTRATOR: 'Remove Administrator?',
    LAST_ADMIN_REMOVE_MESSAGE: 'Group must maintain at least one Group Administrator active at one time.',
};
